import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetch } from '../../helpers/BrowserHelpers';
export function fetchOEmbed(_ref) {
  var url, iframelyApiKey, encodedUrl, apiUrl, response, json;
  return _regeneratorRuntime.async(function fetchOEmbed$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          url = _ref.url, iframelyApiKey = _ref.iframelyApiKey;
          encodedUrl = encodeURIComponent(url);
          apiUrl = "https://iframe.ly/api/iframely?url=".concat(encodedUrl, "&api_key=").concat(iframelyApiKey, "&omit_script=true&ssl=1");
          _context.next = 5;
          return _regeneratorRuntime.awrap(fetch(apiUrl));

        case 5:
          response = _context.sent;
          _context.next = 8;
          return _regeneratorRuntime.awrap(response.json());

        case 8:
          json = _context.sent;

          if (response.ok) {
            _context.next = 12;
            break;
          }

          // eslint-disable-next-line no-console
          console.error("Received the following error from iframely: ".concat(JSON.stringify(json)));
          throw new Error('Unexpected error in iframely call');

        case 12:
          return _context.abrupt("return", json);

        case 13:
        case "end":
          return _context.stop();
      }
    }
  });
}